import React from 'react';

import SideMenuBar from '../../../Components/Layouts/SideMenuBar.jsx';
import TopMenuBar from '../../../Components/Layouts/TopMenuBar.jsx';
import ProfilesettingsMain from './ProfilesettingsMain.jsx';
import './Profilesettings.css';
import { Helmet } from 'react-helmet';
import { SEO } from '../../../Utils/Constant.js';

export default function Profilesettings() {
    return (
        <div className="profile-settings-main">
            <Helmet>
                <title>{SEO.EDIT_PROFILE_PAGE.TITLE}</title>
                <meta name="description" content={SEO.EDIT_PROFILE_PAGE.DESCRIPTION} />
                <meta name="keywords" content={SEO.EDIT_PROFILE_PAGE.KEYWORDS} />
                <meta name="robots" content="index, follow" />
                <link rel="canonical" href={SEO.EDIT_PROFILE_PAGE.CANONICAL} />
                  
                <meta property="og:title" content={SEO.EDIT_PROFILE_PAGE.TITLE} />
                <meta property="og:description" content={SEO.EDIT_PROFILE_PAGE.DESCRIPTION} />
                <meta property="og:type" content={SEO.EDIT_PROFILE_PAGE.OG.TYPE} />
                <meta property="og:url" content={SEO.EDIT_PROFILE_PAGE.OG.URL} />
                <meta property="og:site_name" content={SEO.EDIT_PROFILE_PAGE.OG.SITE_NAME} />
                <meta property="og:image" content='https://omyfood.io/OMF_logo_bg.png' />
                                               
                <meta name="twitter:image" content='https://omyfood.io/OMF_logo_bg.png' />
                <meta name="twitter:title" content={SEO.EDIT_PROFILE_PAGE.TWITTER.TITLE} />
                <meta name="twitter:description" content={SEO.EDIT_PROFILE_PAGE.TWITTER.DESCRIPTION} />
                <meta
                    name="twitter:card"
                    content='summary_large_image'
                />
            </Helmet>
            <div className="profile-settings-sidebar">
                <SideMenuBar></SideMenuBar>
            </div>
            <div className="profile-settings-topbar-and-home">
                <div className="profile-settings-topbar">
                    <TopMenuBar></TopMenuBar>
                </div>
                <div className="profile-settings-home-and-rightbar">
                    <ProfilesettingsMain />
                </div>
            </div>
        </div>
    );
}
